import { useState } from 'react';
import { prefillDemo } from '../api';
import { useDemoStore } from '../store/demo.store';

interface Props {
  context: string;
  /** Si true (défaut) : reçoit le payload côté front pour le poser dans un formulaire. */
  frontOnly?: boolean;
  /** Callback invoqué avec les données pré-remplies (mode front-only). */
  onPrefill?: (data: Record<string, unknown>) => void;
  /** Callback invoqué après création back (mode back-create). */
  onCreated?: (data: Record<string, unknown>) => void;
  className?: string;
}

export function DemoPrefillButton({
  context,
  frontOnly = true,
  onPrefill,
  onCreated,
  className,
}: Props) {
  const enabled = useDemoStore((s) => s.enabled);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!enabled) return null;

  return (
    <div className="inline-flex items-center gap-2">
      <button
        type="button"
        className={
          className ??
          'inline-flex items-center gap-2 rounded-lg border border-amber-400 bg-amber-50 px-3 py-1.5 text-sm font-medium text-amber-900 hover:bg-amber-100 disabled:opacity-60'
        }
        disabled={busy}
        onClick={async () => {
          setBusy(true);
          setError(null);
          try {
            const res = await prefillDemo({ context, create: !frontOnly });
            if (frontOnly) onPrefill?.(res.data);
            else onCreated?.(res.data);
          } catch (err) {
            setError(err instanceof Error ? err.message : 'Échec du prefill');
          } finally {
            setBusy(false);
          }
        }}
      >
        {busy ? 'Préremplissage…' : 'Préremplir démo'}
      </button>
      {error && <span className="text-[0.78rem] text-rose-700">{error}</span>}
    </div>
  );
}
